"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSkuCommentToJSON = exports.CartSkuCommentFromJSONTyped = exports.CartSkuCommentFromJSON = exports.instanceOfCartSkuComment = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CartSkuComment interface.
 */
function instanceOfCartSkuComment(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCartSkuComment = instanceOfCartSkuComment;
function CartSkuCommentFromJSON(json) {
    return CartSkuCommentFromJSONTyped(json, false);
}
exports.CartSkuCommentFromJSON = CartSkuCommentFromJSON;
function CartSkuCommentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
        'skuPattern': !(0, runtime_1.exists)(json, 'skuPattern') ? undefined : json['skuPattern'],
    };
}
exports.CartSkuCommentFromJSONTyped = CartSkuCommentFromJSONTyped;
function CartSkuCommentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'skuPattern': value.skuPattern,
    };
}
exports.CartSkuCommentToJSON = CartSkuCommentToJSON;
